module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/main/energy/energy-default/energy-default.component.css
// module id = ./src/app/components/calculator/calculator-item/shared/main/energy/energy-default/energy-default.component.css
// module chunks = main